import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ className = "", ...props }) {
  const [show, setShow] = useState(false);
  const tid = props["data-testid"] || "password";
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} className={`pr-10 ${className}`} />
      <button type="button" tabIndex={-1} data-testid={`${tid}-toggle`} onClick={() => setShow((s) => !s)}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-slate-400 hover:text-white transition-colors">
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
